/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown>, product: NonNullable<unknown> }} Order_Unpaid_MessageInputs */

const en_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`We couldn't recover your credentials for ${i?.displayName} since the purchase is not paid.`);
	return /** @type {LocalizedString} */ (`We couldn't recover your credentials for ${i?.displayName} since the subscription is not paid.`)
	
};

const id_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kami tidak dapat memulihkan kredensial Anda untuk ${i?.displayName} karena pembelian belum dibayar.`);
	return /** @type {LocalizedString} */ (`Kami tidak dapat memulihkan kredensial Anda untuk ${i?.displayName} karena langganan belum dibayar.`)
	
};

const ms_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kami tidak dapat memulihkan kelayakan anda untuk ${i?.displayName} kerana pembelian itu belum dibayar.`);
	return /** @type {LocalizedString} */ (`Kami tidak dapat memulihkan bukti kelayakan anda untuk ${i?.displayName} oleh kerana langganan belum dibayar.`)
	
};

const ca_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`No hem pogut recuperar les teves credencials per a ${i?.displayName} perquè la compra no està pagada.`);
	return /** @type {LocalizedString} */ (`No hem pogut recuperar les teves credencials per ${i?.displayName}, ja que no s'ha abonat la subscripció.`)
	
};

const cs_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nemohli jsme obnovit vaše přihlašovací údaje pro ${i?.displayName}, protože nákup není zaplacen.`);
	return /** @type {LocalizedString} */ (`Vaše přihlašovací údaje pro ${i?.displayName} se nám nepodařilo obnovit, protože předplatné není zaplaceno.`)
	
};

const da_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi kunne ikke genskabe dine legitimationsoplysninger til ${i?.displayName}, da købet ikke er betalt.`);
	return /** @type {LocalizedString} */ (`Vi kunne ikke gendanne dine legitimationsoplysninger til ${i?.displayName}, da abonnementet ikke er betalt.`)
	
};

const de_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Wir konnten Ihre Anmeldedaten für ${i?.displayName} nicht wiederherstellen, da der Kauf nicht bezahlt wurde.`);
	return /** @type {LocalizedString} */ (`Wir konnten Ihre Anmeldedaten für ${i?.displayName} nicht wiederherstellen, da das Abonnement nicht bezahlt wurde.`)
	
};

const et_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Me ei saanud sinu ${i?.displayName} mandaate taastada, kuna ost ei ole tasutud.`);
	return /** @type {LocalizedString} */ (`Me ei saanud teie teenuse ${i?.displayName} mandaate taastada, kuna tellimuse eest ei ole makstud.`)
	
};

const es_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`No pudimos recuperar tus credenciales de ${i?.displayName} porque la compra no ha sido pagada.`);
	return /** @type {LocalizedString} */ (`No pudimos obtener tus credenciales de ${i?.displayName} porque la suscripción no está paga.`)
	
};

const fr_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nous n’avons pas pu récupérer vos identifiants pour ${i?.displayName}, car l’achat n’a pas été réglé.`);
	return /** @type {LocalizedString} */ (`Nous n’avons pas pu récupérer vos identifiants pour ${i?.displayName}, car l’abonnement n’est pas actif.`)
	
};

const hr_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nismo mogli povratiti vaše vjerodajnice za ${i?.displayName} jer kupnja nije plaćena.`);
	return /** @type {LocalizedString} */ (`Nismo mogli vratiti vaše vjerodajnice za ${i?.displayName} budući da pretplata nije plaćena.`)
	
};

const it_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Non abbiamo potuto recuperare le tue credenziali per ${i?.displayName} poiché l'acquisto non è stato pagato.`);
	return /** @type {LocalizedString} */ (`Non siamo riusciti a recuperare le tue credenziali per ${i?.displayName}: l'abbonamento non è stato pagato.`)
	
};

const lv_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mēs nevarējām atjaunot jūsu ${i?.displayName} akreditācijas datus, jo pirkums nav apmaksāts.`);
	return /** @type {LocalizedString} */ (`Mums neizdevās atjaunot jūsu piekļuvi ${i?.displayName}, jo abonements nav apmaksāts.`)
	
};

const lt_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Negalėjome atkurti jūsų ${i?.displayName} kredencialų, nes pirkinys nėra apmokėtas.`);
	return /** @type {LocalizedString} */ (`Negalėjome atkurti prieigos prie ${i?.displayName}, nes nebuvo sumokėta už prenumeratą.`)
	
};

const hu_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nem tudtuk visszaállítani a ${i?.displayName} hitelesítő adataidat, mivel a vásárlás nincs kifizetve.`);
	return /** @type {LocalizedString} */ (`Nem sikerült visszaállítani az Ön hitelesítő adatait a ${i?.displayName} szolgáltatáshoz, mivel az előfizetés nincs kifizetve.`)
	
};

const nl_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`We konden je inloggegevens voor ${i?.displayName} niet herstellen omdat de aankoop niet is betaald.`);
	return /** @type {LocalizedString} */ (`We konden je inloggegevens voor ${i?.displayName} niet ophalen omdat het abonnement niet betaald is.`)
	
};

const nb_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi kunne ikke gjenopprette legitimasjonen din for ${i?.displayName} siden kjøpet ikke er betalt.`);
	return /** @type {LocalizedString} */ (`Vi kunne ikke gjenopprette ${i?.displayName}-brukeren din fordi abonnementet ikke er betalt.`)
	
};

const pl_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nie mogliśmy uzyskać Twoich danych uwierzytelniających dla ${i?.displayName}, ponieważ zakup nie został opłacony.`);
	return /** @type {LocalizedString} */ (`Nie mogliśmy uzyskać Twoich danych uwierzytelniających dla ${i?.displayName} , ponieważ subskrypcja nie jest opłacona.`)
	
};

const pt_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Não foi possível recuperar suas credenciais do ${i?.displayName}, pois a compra não foi paga.`);
	return /** @type {LocalizedString} */ (`Não foi possível recuperar suas credenciais do  ${i?.displayName}, pois a assinatura não foi paga.`)
	
};

const ro_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nu am putut recupera credențialele tale pentru ${i?.displayName} deoarece achiziția nu este plătită.`);
	return /** @type {LocalizedString} */ (`Nu am putut recupera datele tale de identificare pentru ${i?.displayName} deoarece abonamentul nu este plătit.`)
	
};

const sk_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nepodarilo sa nám obnoviť vaše prihlasovacie údaje pre ${i?.displayName}, pretože nákup nie je zaplatený.`);
	return /** @type {LocalizedString} */ (`Nemohli sme obnoviť vaše údaje pre ${i?.displayName}, pretože predplatné nie je zaplatené.`)
	
};

const sl_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vaših poverilnic za ${i?.displayName} nismo mogli obnoviti, ker nakup ni plačan.`);
	return /** @type {LocalizedString} */ (`Vaših poverilnic za »${i?.displayName}« nismo mogli obnoviti, ker naročnina ni plačana.`)
	
};

const fi_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Emme voineet palauttaa tunnistetietojasi tuotteelle ${i?.displayName}, koska ostoa ei ole maksettu.`);
	return /** @type {LocalizedString} */ (`Emme voineet palauttaa tunnuksiasi kohteelle ${i?.displayName}, koska tilausta ei ole maksettu.`)
	
};

const sv_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi kunde inte återställa dina inloggningsuppgifter för ${i?.displayName} eftersom köpet inte är betalt.`);
	return /** @type {LocalizedString} */ (`Vi kunde inte återställa dina inloggningsuppgifter för ${i?.displayName} eftersom prenumerationen inte är betald.`)
	
};

const vi_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Chúng tôi không thể khôi phục thông tin xác thực của bạn cho ${i?.displayName} vì mua hàng chưa được thanh toán.`);
	return /** @type {LocalizedString} */ (`Chúng tôi không thể khôi phục thông tin đăng nhập của bạn cho ${i?.displayName} vì gói đăng ký chưa được thanh toán.`)
	
};

const tr_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Satın alma ödenmediği için ${i?.displayName} kimlik bilgilerinizi kurtaramadık.`);
	return /** @type {LocalizedString} */ (`Abonelik bedeli ödenmediğinden ${i?.displayName} için kimlik bilgilerinizi kurtaramadık.`)
	
};

const el_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Δεν μπορέσαμε να ανακτήσουμε τα διαπιστευτήριά σας για το ${i?.displayName} επειδή η αγορά δεν είναι πληρωμένη.`);
	return /** @type {LocalizedString} */ (`Δεν μπορέσαμε να ανακτήσουμε τα διαπιστευτήριά σας για το ${i?.displayName}, καθώς η συνδρομή δεν έχει πληρωθεί.`)
	
};

const bg_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Не можахме да възстановим вашите идентификационни данни за ${i?.displayName}, тъй като покупката не е платена.`);
	return /** @type {LocalizedString} */ (`Не успяхме да възстановим твоите идентификационни данни за ${i?.displayName}, тъй като абонаментът не е платен.`)
	
};

const ru_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Мы не смогли восстановить ваши учётные данные для ${i?.displayName}, поскольку покупка не оплачена.`);
	return /** @type {LocalizedString} */ (`Мы не смогли восстановить ваши учетные данные для ${i?.displayName}, так как подписка не оплачена.`)
	
};

const sr_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Нисмо могли да опоравимо ваше акредитиве за ${i?.displayName} јер куповина није плаћена.`);
	return /** @type {LocalizedString} */ (`Нисмо успели да вратимо ваше акредитиве за функцију ${i?.displayName} јер претплата није плаћена.`)
	
};

const uk_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ми не змогли відновити ваші облікові дані для ${i?.displayName}, оскільки покупка не оплачена.`);
	return /** @type {LocalizedString} */ (`Ми не змогли відновити ваші облікові дані для ${i?.displayName}, оскільки підписка не оплачена.`)
	
};

const ka_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`ჩვენ ვერ აღვადგინეთ თქვენი ${i?.displayName}-ის რწმუნებები, რადგან შეძენა გადახდილი არ არის.`);
	return /** @type {LocalizedString} */ (`${i?.displayName}-ისთვის თქვენი ავტორიზაციის მონაცემების აღდგენა ვერ მოხერხდა, რადგან გამოწერა გადახდილი არ არის.`)
	
};

const hi_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`हम ${i?.displayName} के लिए आपकी क्रेडेंशियल पुनर्प्राप्त नहीं कर सके क्योंकि खरीद का भुगतान नहीं किया गया है।`);
	return /** @type {LocalizedString} */ (`हम ${i?.displayName} के लिए आपके क्रेडेंशियल रिकवर नहीं कर सके, क्योंकि सब्सक्रिप्शन का पेमेंट नहीं हुआ है।`)
	
};

const th_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`เราไม่สามารถกู้คืนข้อมูลรับรองของคุณสำหรับ ${i?.displayName} ได้เนื่องจากการซื้อยังไม่ได้ชำระเงิน`);
	return /** @type {LocalizedString} */ (`เราไม่สามารถกู้คืนข้อมูลประจำตัวของคุณสำหรับ ${i?.displayName} ได้ เนื่องจากยังไม่ได้รับการชำระเงินสำหรับการสมัครสมาชิก`)
	
};

const ko_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`구매가 결제되지 않아 ${i?.displayName}의 자격 증명을 복구할 수 없습니다.`);
	return /** @type {LocalizedString} */ (`구독이 결제되지 않아 ${i?.displayName}에 대한 자격 증명을 복원할 수 없습니다.`)
	
};

const zh_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们无法恢复您的 ${i?.displayName} 凭据，因为该订阅未支付。`)
};

const zh_tw_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`由於該購買尚未付款，我們無法還原您的 ${i?.displayName} 憑證。`);
	return /** @type {LocalizedString} */ (`由於訂閱尚未付款，我們無法為 ${i?.displayName} 取回您的認證資料。`)
	
};

const ja_order_unpaid_message = /** @type {(inputs: Order_Unpaid_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`購入が支払われていないため、${i?.displayName} の認証情報を復元できませんでした。`);
	return /** @type {LocalizedString} */ (`サブスクリプションの支払いが済んでいないため、 ${i?.displayName} の認証情報を回復できませんでした。`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "We couldn't recover your credentials for {displayName} since the purchase is not paid." |
* | * | "We couldn't recover your credentials for {displayName} since the subscription is not paid." |
*
* @param {Order_Unpaid_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const order_unpaid_message = /** @type {((inputs: Order_Unpaid_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Unpaid_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_order_unpaid_message(inputs)
	if (locale === "ms") return ms_order_unpaid_message(inputs)
	if (locale === "ca") return ca_order_unpaid_message(inputs)
	if (locale === "cs") return cs_order_unpaid_message(inputs)
	if (locale === "da") return da_order_unpaid_message(inputs)
	if (locale === "de") return de_order_unpaid_message(inputs)
	if (locale === "et") return et_order_unpaid_message(inputs)
	if (locale === "es") return es_order_unpaid_message(inputs)
	if (locale === "fr") return fr_order_unpaid_message(inputs)
	if (locale === "hr") return hr_order_unpaid_message(inputs)
	if (locale === "it") return it_order_unpaid_message(inputs)
	if (locale === "lv") return lv_order_unpaid_message(inputs)
	if (locale === "lt") return lt_order_unpaid_message(inputs)
	if (locale === "hu") return hu_order_unpaid_message(inputs)
	if (locale === "nl") return nl_order_unpaid_message(inputs)
	if (locale === "nb") return nb_order_unpaid_message(inputs)
	if (locale === "pl") return pl_order_unpaid_message(inputs)
	if (locale === "pt") return pt_order_unpaid_message(inputs)
	if (locale === "ro") return ro_order_unpaid_message(inputs)
	if (locale === "sk") return sk_order_unpaid_message(inputs)
	if (locale === "sl") return sl_order_unpaid_message(inputs)
	if (locale === "fi") return fi_order_unpaid_message(inputs)
	if (locale === "sv") return sv_order_unpaid_message(inputs)
	if (locale === "vi") return vi_order_unpaid_message(inputs)
	if (locale === "tr") return tr_order_unpaid_message(inputs)
	if (locale === "el") return el_order_unpaid_message(inputs)
	if (locale === "bg") return bg_order_unpaid_message(inputs)
	if (locale === "ru") return ru_order_unpaid_message(inputs)
	if (locale === "sr") return sr_order_unpaid_message(inputs)
	if (locale === "uk") return uk_order_unpaid_message(inputs)
	if (locale === "ka") return ka_order_unpaid_message(inputs)
	if (locale === "hi") return hi_order_unpaid_message(inputs)
	if (locale === "th") return th_order_unpaid_message(inputs)
	if (locale === "ko") return ko_order_unpaid_message(inputs)
	if (locale === "zh") return zh_order_unpaid_message(inputs)
	if (locale === "zh-tw") return zh_tw_order_unpaid_message(inputs)
	if (locale === "ja") return ja_order_unpaid_message(inputs)
	return en_order_unpaid_message(inputs)
});